var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors && _vm.errors.length)?_c('ul',{staticClass:"alert alert--danger mb-3",attrs:{"role":"alert"}},_vm._l((_vm.errors),function(error,errorIndex){return _c('li',{key:errorIndex},[_vm._v("\n    "+_vm._s(error[0])+"\n  ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }